{
  "lexicon": {
    "directions": [
      {
        "aliases": ["d", "descend", "downstairs", "downward"],
        "canonicalToken": "down"
      },
      {
        "aliases": ["e"],
        "canonicalToken": "east"
      },
      {
        "aliases": ["inside", "enter", "into"],
        "canonicalToken": "in"
      },
      {
        "aliases": ["n"],
        "canonicalToken": "north"
      },
      {
        "aliases": ["ne", "north east", "north-east"],
        "canonicalToken": "northeast"
      },
      {
        "aliases": ["nw", "north west", "north-west"],
        "canonicalToken": "northwest"
      },
      {
        "aliases": ["depart", "exit", "outside"],
        "canonicalToken": "out"
      },
      {
        "aliases": ["s"],
        "canonicalToken": "south"
      },
      {
        "aliases": ["se", "south east", "south-east"],
        "canonicalToken": "southeast"
      },
      {
        "aliases": ["sw", "south west", "south-west"],
        "canonicalToken": "southwest"
      },
      {
        "aliases": ["ascend", "u", "upstairs", "upward"],
        "canonicalToken": "up"
      },
      {
        "aliases": ["w"],
        "canonicalToken": "west"
      }
    ],
    "intents": [
      {
        "aliases": ["g", "repeat"],
        "canonicalToken": "again",
        "objectPolicy": "forbidden"
      },
      {
        "aliases": [
          "greet",
          "query",
          "question",
          "speak",
          "speak with",
          "talk",
          "talk with",
          "tell",
          "tell me about",
          "what about",
          "who is",
          "who's",
          "whos"
        ],
        "canonicalToken": "ask",
        "objectPolicy": "optional",
        "prepositionBindings": [
          {
            "bindsAs": "indirect_object",
            "preposition": "about"
          }
        ]
      },
      {
        "aliases": ["fight", "hit", "kill", "punch", "strike"],
        "canonicalToken": "attack",
        "objectPolicy": "required",
        "objectPreference": "present",
        "prepositionBindings": [
          { "bindsAs": "tool", "preposition": "with" },
          { "bindsAs": "tool", "preposition": "using" }
        ]
      },
      {
        "aliases": ["bash", "break into", "destroy", "smash"],
        "canonicalToken": "break",
        "isUnsupported": true,
        "objectPolicy": "required",
        "particles": ["down"]
      },
      {
        "aliases": ["ignite", "light on fire"],
        "canonicalToken": "burn",
        "isUnsupported": true,
        "objectPolicy": "required"
      },
      {
        "aliases": ["scale"],
        "bareDirection": "up",
        "canonicalToken": "climb",
        "isUnsupported": true,
        "objectPolicy": "optional",
        "prepositionBindings": [
          {
            "bindsAs": "indirect_object",
            "preposition": "into"
          }
        ]
      },
      {
        "aliases": ["shut"],
        "canonicalToken": "close",
        "objectPolicy": "required"
      },
      {
        "aliases": ["slice"],
        "canonicalToken": "cut",
        "isUnsupported": true,
        "objectPolicy": "required"
      },
      {
        "aliases": ["discard", "put down", "set down"],
        "canonicalToken": "drop",
        "objectPolicy": "required",
        "objectPreference": "carried"
      },
      {
        "aliases": ["taste"],
        "canonicalToken": "eat",
        "isUnsupported": true,
        "objectPolicy": "required"
      },
      {
        "aliases": ["don", "put on", "wear"],
        "canonicalToken": "equip",
        "objectPolicy": "required",
        "objectPreference": "carried"
      },
      {
        "aliases": ["hand", "offer"],
        "canonicalToken": "give",
        "objectPolicy": "required",
        "objectPreference": "carried",
        "prepositionBindings": [
          {
            "bindsAs": "indirect_object",
            "preposition": "to"
          }
        ]
      },
      {
        "aliases": ["board", "get in", "get into", "head", "move", "ride", "step", "travel", "walk"],
        "canonicalToken": "go",
        "objectPolicy": "optional"
      },
      {
        "aliases": ["commands", "hint", "hints", "what can i do", "what do i do"],
        "canonicalToken": "help",
        "objectPolicy": "forbidden"
      },
      {
        "aliases": [
          "check",
          "examine",
          "how is",
          "how's",
          "hows",
          "look at",
          "look in",
          "read",
          "study",
          "what is",
          "what's",
          "whats",
          "where is",
          "where's",
          "wheres",
          "x"
        ],
        "canonicalToken": "inspect",
        "objectPolicy": "required",
        "objectPreference": "present"
      },
      {
        "aliases": ["i", "inv", "items", "what am i carrying", "what do i have"],
        "canonicalToken": "inventory",
        "objectPolicy": "forbidden"
      },
      {
        "aliases": ["stomp"],
        "canonicalToken": "kick",
        "isUnsupported": true,
        "objectPolicy": "required",
        "particles": ["down", "in"]
      },
      {
        "aliases": ["rap"],
        "canonicalToken": "knock",
        "isUnsupported": true,
        "objectPolicy": "optional",
        "prepositionBindings": [
          {
            "bindsAs": "indirect_object",
            "preposition": "on"
          },
          {
            "bindsAs": "indirect_object",
            "preposition": "at"
          }
        ]
      },
      {
        "aliases": [],
        "canonicalToken": "listen",
        "isUnsupported": true,
        "objectPolicy": "optional"
      },
      {
        "aliases": [],
        "canonicalToken": "lock",
        "isUnsupported": true,
        "objectPolicy": "required"
      },
      {
        "aliases": ["l", "look around", "what do i see", "where am i"],
        "canonicalToken": "look",
        "objectPolicy": "forbidden"
      },
      {
        "aliases": ["chart", "layout", "plan", "where am i going", "where have i been"],
        "canonicalToken": "map",
        "objectPolicy": "forbidden"
      },
      {
        "aliases": ["load game", "restore"],
        "canonicalToken": "load",
        "objectPolicy": "forbidden"
      },
      {
        "aliases": ["never mind"],
        "canonicalToken": "nevermind",
        "objectPolicy": "forbidden"
      },
      {
        "aliases": [
          "bash open",
          "break open",
          "force open",
          "kick open",
          "lever open",
          "pry open",
          "push open",
          "smash open",
          "unlock",
          "wrench open"
        ],
        "canonicalToken": "open",
        "objectPolicy": "required",
        "prepositionBindings": [
          {
            "bindsAs": "tool",
            "preposition": "with"
          },
          {
            "bindsAs": "tool",
            "preposition": "using"
          }
        ]
      },
      {
        "aliases": ["press"],
        "canonicalToken": "push",
        "isUnsupported": true,
        "objectPolicy": "optional",
        "prepositionBindings": [
          {
            "bindsAs": "indirect_object",
            "preposition": "on"
          },
          {
            "bindsAs": "indirect_object",
            "preposition": "against"
          }
        ]
      },
      {
        "aliases": [],
        "canonicalToken": "remove",
        "objectPolicy": "required"
      },
      {
        "aliases": ["begin again", "start over"],
        "canonicalToken": "restart",
        "objectPolicy": "forbidden"
      },
      {
        "aliases": ["save game"],
        "canonicalToken": "save",
        "objectPolicy": "forbidden"
      },
      {
        "aliases": ["rummage", "rummage through", "search through", "look through", "go through"],
        "canonicalToken": "search",
        "objectPolicy": "optional",
        "prepositionBindings": [
          {
            "bindsAs": "indirect_object",
            "preposition": "behind"
          },
          {
            "bindsAs": "indirect_object",
            "preposition": "for"
          }
        ]
      },
      {
        "aliases": [],
        "canonicalToken": "show",
        "objectPolicy": "required",
        "objectPreference": "carried",
        "prepositionBindings": [
          {
            "bindsAs": "indirect_object",
            "preposition": "to"
          }
        ]
      },
      {
        "aliases": ["sniff"],
        "canonicalToken": "smell",
        "isUnsupported": true,
        "objectPolicy": "optional"
      },
      {
        "aliases": ["collect", "get", "grab", "lift", "pick up", "pull"],
        "canonicalToken": "take",
        "objectPolicy": "required",
        "objectPreference": "present",
        "prepositionBindings": [{ "bindsAs": "indirect_object", "locatesObject": true, "preposition": "from" }]
      },
      {
        "aliases": ["toss"],
        "canonicalToken": "throw",
        "isUnsupported": true,
        "objectPolicy": "optional",
        "prepositionBindings": [
          {
            "bindsAs": "indirect_object",
            "preposition": "at"
          }
        ]
      },
      {
        "aliases": ["feel", "poke", "prod"],
        "canonicalToken": "touch",
        "isUnsupported": true,
        "objectPolicy": "required"
      },
      {
        "aliases": ["flick", "flip", "power", "rotate", "switch", "toggle", "twist"],
        "canonicalToken": "turn",
        "isUnsupported": true,
        "objectPolicy": "required",
        "particles": ["off", "on"]
      },
      {
        "aliases": ["doff", "take off"],
        "canonicalToken": "unequip",
        "objectPolicy": "required",
        "objectPreference": "carried"
      },
      {
        "aliases": [],
        "canonicalToken": "use",
        "objectPolicy": "required",
        "prepositionBindings": [
          {
            "bindsAs": "indirect_object",
            "preposition": "on"
          },
          {
            "bindsAs": "tool",
            "preposition": "with"
          },
          {
            "bindsAs": "tool",
            "preposition": "using"
          }
        ]
      },
      {
        "aliases": ["hold on", "rest", "stand by", "z"],
        "canonicalToken": "wait",
        "objectPolicy": "forbidden"
      }
    ],
    "interrogativeLeaders": [
      "am",
      "are",
      "be",
      "can",
      "could",
      "did",
      "do",
      "does",
      "had",
      "has",
      "have",
      "how",
      "how's",
      "hows",
      "is",
      "may",
      "might",
      "must",
      "shall",
      "should",
      "was",
      "were",
      "what",
      "what's",
      "whats",
      "when",
      "where",
      "where's",
      "wheres",
      "which",
      "who",
      "who's",
      "whom",
      "whos",
      "whose",
      "why",
      "will",
      "would"
    ],
    "movementIntentToken": "go",
    "orderLeaders": ["ask", "command", "instruct", "order", "tell"],
    "recognitionWords": [
      "a",
      "able",
      "about",
      "above",
      "afraid",
      "after",
      "again",
      "against",
      "aim",
      "air",
      "alive",
      "all",
      "almost",
      "alone",
      "also",
      "although",
      "always",
      "am",
      "an",
      "anchor",
      "and",
      "angry",
      "animal",
      "answer",
      "any",
      "anybody",
      "anyone",
      "anything",
      "anyway",
      "apologize",
      "are",
      "arm",
      "around",
      "as",
      "ask",
      "asleep",
      "at",
      "attach",
      "awake",
      "aware",
      "away",
      "back",
      "bad",
      "badge",
      "bail",
      "bake",
      "be",
      "beat",
      "beautiful",
      "because",
      "bed",
      "been",
      "before",
      "begin",
      "behind",
      "being",
      "believe",
      "belong",
      "below",
      "bench",
      "bend",
      "beside",
      "best",
      "better",
      "between",
      "big",
      "bind",
      "bird",
      "bit",
      "bite",
      "black",
      "blow",
      "blue",
      "body",
      "boil",
      "book",
      "borrow",
      "both",
      "bow",
      "box",
      "boy",
      "break",
      "breaker",
      "breath",
      "bright",
      "bring",
      "broken",
      "brother",
      "brown",
      "build",
      "burn",
      "bury",
      "busy",
      "but",
      "buy",
      "by",
      "call",
      "calm",
      "can",
      "cannot",
      "car",
      "card",
      "care",
      "caress",
      "carry",
      "carve",
      "cat",
      "catch",
      "ceiling",
      "certain",
      "chain",
      "chair",
      "chance",
      "change",
      "chase",
      "chew",
      "child",
      "children",
      "choose",
      "chop",
      "clean",
      "clear",
      "clever",
      "climb",
      "close",
      "cold",
      "collect",
      "color",
      "come",
      "comfortable",
      "concrete",
      "console",
      "cook",
      "cool",
      "cough",
      "could",
      "count",
      "country",
      "cover",
      "crack",
      "crawl",
      "crazy",
      "cross",
      "crouch",
      "cry",
      "cut",
      "damage",
      "dance",
      "danger",
      "dangerous",
      "dark",
      "day",
      "dead",
      "dear",
      "death",
      "decide",
      "deep",
      "desk",
      "did",
      "die",
      "different",
      "difficult",
      "dig",
      "dirty",
      "dive",
      "do",
      "dodge",
      "does",
      "dog",
      "doing",
      "done",
      "door",
      "doubt",
      "douse",
      "down",
      "doze",
      "drag",
      "draw",
      "dream",
      "drink",
      "drive",
      "drop",
      "dry",
      "duck",
      "during",
      "dust",
      "each",
      "ear",
      "early",
      "earth",
      "easy",
      "eat",
      "either",
      "else",
      "embrace",
      "empty",
      "end",
      "enjoy",
      "enough",
      "enter",
      "even",
      "evening",
      "ever",
      "every",
      "everybody",
      "everyone",
      "everything",
      "exactly",
      "except",
      "exit",
      "explain",
      "extinguish",
      "eye",
      "face",
      "facility",
      "fact",
      "fall",
      "family",
      "far",
      "fast",
      "fat",
      "father",
      "fathom",
      "fault",
      "fear",
      "feed",
      "feel",
      "feeling",
      "feet",
      "few",
      "fight",
      "fill",
      "find",
      "fine",
      "finger",
      "finish",
      "fire",
      "first",
      "fish",
      "fit",
      "fix",
      "flee",
      "fling",
      "float",
      "floor",
      "fly",
      "fold",
      "follow",
      "food",
      "foot",
      "for",
      "force",
      "forget",
      "forward",
      "free",
      "freeze",
      "fresh",
      "friend",
      "from",
      "front",
      "frown",
      "full",
      "fun",
      "funny",
      "future",
      "game",
      "garden",
      "gate",
      "gather",
      "gentle",
      "get",
      "girl",
      "give",
      "glad",
      "glass",
      "go",
      "gone",
      "good",
      "grab",
      "grasp",
      "gray",
      "great",
      "green",
      "greet",
      "grille",
      "grip",
      "ground",
      "grow",
      "guess",
      "hack",
      "had",
      "hair",
      "half",
      "hand",
      "hang",
      "happen",
      "happy",
      "hard",
      "harvest",
      "has",
      "hate",
      "haul",
      "have",
      "having",
      "he",
      "head",
      "hear",
      "heart",
      "heat",
      "heavy",
      "hello",
      "help",
      "her",
      "here",
      "hers",
      "herself",
      "hide",
      "high",
      "him",
      "himself",
      "his",
      "hit",
      "hoist",
      "hold",
      "hole",
      "home",
      "hook",
      "hop",
      "hope",
      "hot",
      "hour",
      "house",
      "hover",
      "how",
      "hug",
      "hum",
      "human",
      "hungry",
      "hunt",
      "hurl",
      "hurry",
      "hurt",
      "i",
      "idea",
      "if",
      "important",
      "in",
      "insert",
      "inside",
      "instead",
      "into",
      "is",
      "it",
      "its",
      "itself",
      "jam",
      "jog",
      "jump",
      "keep",
      "kettle",
      "key",
      "kick",
      "kill",
      "kind",
      "kiss",
      "kneel",
      "knit",
      "knock",
      "knot",
      "know",
      "lamp",
      "land",
      "large",
      "lash",
      "last",
      "late",
      "laugh",
      "lazy",
      "lead",
      "lean",
      "leap",
      "learn",
      "least",
      "leave",
      "left",
      "leg",
      "lend",
      "less",
      "let",
      "lick",
      "lie",
      "life",
      "lift",
      "light",
      "like",
      "listen",
      "little",
      "live",
      "load",
      "lob",
      "lock",
      "locker",
      "log",
      "lonely",
      "long",
      "look",
      "lose",
      "lost",
      "loud",
      "love",
      "low",
      "lower",
      "lucky",
      "mad",
      "make",
      "man",
      "many",
      "march",
      "matter",
      "may",
      "maybe",
      "me",
      "mean",
      "measure",
      "meet",
      "melt",
      "memory",
      "men",
      "mend",
      "might",
      "mind",
      "mine",
      "minute",
      "miss",
      "moment",
      "money",
      "month",
      "moon",
      "moor",
      "more",
      "morning",
      "most",
      "mother",
      "mount",
      "mountain",
      "mourn",
      "mouth",
      "move",
      "mow",
      "much",
      "mud",
      "music",
      "must",
      "my",
      "myself",
      "name",
      "nap",
      "near",
      "need",
      "never",
      "new",
      "next",
      "nice",
      "night",
      "no",
      "nobody",
      "nod",
      "noise",
      "none",
      "nor",
      "normal",
      "nose",
      "not",
      "nothing",
      "now",
      "number",
      "of",
      "off",
      "offer",
      "often",
      "old",
      "on",
      "once",
      "one",
      "only",
      "open",
      "or",
      "orange",
      "order",
      "other",
      "others",
      "our",
      "ours",
      "ourselves",
      "out",
      "outside",
      "over",
      "owe",
      "own",
      "paddle",
      "pain",
      "paint",
      "panel",
      "paper",
      "part",
      "pass",
      "past",
      "pat",
      "patch",
      "pay",
      "people",
      "perhaps",
      "person",
      "pet",
      "pick",
      "picture",
      "piece",
      "pipe",
      "place",
      "plan",
      "plant",
      "play",
      "plow",
      "pluck",
      "pocket",
      "point",
      "polish",
      "poor",
      "possible",
      "pour",
      "power",
      "pray",
      "press",
      "pretty",
      "problem",
      "promise",
      "prune",
      "pry",
      "pull",
      "punch",
      "push",
      "put",
      "question",
      "quick",
      "quiet",
      "quite",
      "rain",
      "raise",
      "rather",
      "rattle",
      "reach",
      "read",
      "ready",
      "real",
      "reap",
      "reason",
      "red",
      "release",
      "reload",
      "remember",
      "remove",
      "repair",
      "reply",
      "rest",
      "return",
      "rich",
      "ride",
      "right",
      "ring",
      "rip",
      "rise",
      "river",
      "road",
      "rock",
      "roll",
      "room",
      "roster",
      "rough",
      "round",
      "row",
      "rub",
      "run",
      "rust",
      "sad",
      "safe",
      "said",
      "sail",
      "same",
      "saw",
      "say",
      "says",
      "scared",
      "score",
      "scrape",
      "scratch",
      "screen",
      "scrub",
      "sea",
      "search",
      "seat",
      "second",
      "see",
      "seek",
      "seem",
      "sell",
      "send",
      "sense",
      "serious",
      "sew",
      "shake",
      "sharp",
      "she",
      "shift",
      "shine",
      "shoot",
      "short",
      "should",
      "shout",
      "shove",
      "show",
      "shrug",
      "shut",
      "sick",
      "side",
      "sign",
      "silence",
      "silent",
      "simple",
      "since",
      "sing",
      "sink",
      "sister",
      "sit",
      "site",
      "skip",
      "slap",
      "sleep",
      "slice",
      "slow",
      "small",
      "smart",
      "smash",
      "smell",
      "smile",
      "sneeze",
      "snow",
      "so",
      "soar",
      "soft",
      "some",
      "somebody",
      "someone",
      "something",
      "sometimes",
      "son",
      "song",
      "soon",
      "sorry",
      "sound",
      "sow",
      "speak",
      "special",
      "spell",
      "spend",
      "spin",
      "spit",
      "split",
      "sprint",
      "squeeze",
      "stab",
      "stair",
      "stairs",
      "stairwell",
      "stand",
      "star",
      "start",
      "stay",
      "steal",
      "steel",
      "steer",
      "step",
      "still",
      "stir",
      "stitch",
      "stomp",
      "stone",
      "stop",
      "story",
      "straight",
      "strange",
      "street",
      "strike",
      "stroke",
      "strong",
      "stupid",
      "such",
      "suck",
      "sun",
      "sure",
      "surface",
      "surprise",
      "swallow",
      "sweet",
      "swim",
      "switch",
      "system",
      "take",
      "talk",
      "tall",
      "tap",
      "taste",
      "tea",
      "teach",
      "tear",
      "tell",
      "terrible",
      "than",
      "thank",
      "thanks",
      "that",
      "the",
      "their",
      "theirs",
      "them",
      "themselves",
      "then",
      "there",
      "these",
      "they",
      "thick",
      "thin",
      "thing",
      "things",
      "think",
      "this",
      "those",
      "thought",
      "through",
      "throw",
      "tie",
      "till",
      "time",
      "tired",
      "to",
      "today",
      "together",
      "tomorrow",
      "too",
      "toss",
      "touch",
      "town",
      "trade",
      "tree",
      "trim",
      "trouble",
      "true",
      "trust",
      "try",
      "tug",
      "turn",
      "twist",
      "ugly",
      "under",
      "understand",
      "unearth",
      "unlock",
      "untie",
      "until",
      "up",
      "upon",
      "us",
      "use",
      "vault",
      "vent",
      "very",
      "voice",
      "wade",
      "wait",
      "wake",
      "walk",
      "wall",
      "want",
      "warm",
      "was",
      "wash",
      "watch",
      "water",
      "wave",
      "way",
      "we",
      "weak",
      "wear",
      "weather",
      "weave",
      "wedge",
      "week",
      "weep",
      "weigh",
      "weird",
      "well",
      "were",
      "wet",
      "what",
      "whatever",
      "when",
      "whenever",
      "where",
      "wherever",
      "whether",
      "which",
      "while",
      "whisper",
      "whistle",
      "white",
      "who",
      "whole",
      "whom",
      "whose",
      "why",
      "wide",
      "wild",
      "will",
      "win",
      "wind",
      "window",
      "wipe",
      "wish",
      "with",
      "within",
      "without",
      "woman",
      "women",
      "wonder",
      "wood",
      "word",
      "work",
      "world",
      "worry",
      "worse",
      "worst",
      "would",
      "write",
      "wrong",
      "yank",
      "year",
      "yell",
      "yellow",
      "yes",
      "yesterday",
      "yet",
      "you",
      "young",
      "your",
      "yours",
      "yourself"
    ],
    "socialWords": [
      "apologies",
      "bye",
      "cheers",
      "cool",
      "farewell",
      "goodbye",
      "greetings",
      "hello",
      "hey",
      "hi",
      "howdy",
      "nah",
      "nice",
      "no",
      "nope",
      "ok",
      "okay",
      "please",
      "sorry",
      "thank",
      "thanks",
      "welcome",
      "wow",
      "yeah",
      "yep",
      "yes",
      "yo"
    ],
    "statementLeaders": [
      "he",
      "i",
      "i'd",
      "i'll",
      "i'm",
      "i've",
      "id",
      "ill",
      "im",
      "it's",
      "its",
      "ive",
      "mine",
      "my",
      "she",
      "that",
      "that's",
      "thats",
      "there",
      "there's",
      "theres",
      "they",
      "this",
      "we",
      "we're",
      "we've",
      "were",
      "weve",
      "you",
      "you're",
      "youre"
    ],
    "stopwords": ["that", "this", "to"]
  },
  "schemaVersion": "0.5.0"
}
